import React from 'react';
import { Link } from 'react-router-dom';

import SubtleBadge from 'components/common/SubtleBadge';

import paths from 'routes/paths';
import { formatStatus } from 'utils/valueFormatters';
import { getManifestBadgeColor } from 'constants/manifest';
import { TIME_OPTION } from 'constants/time';

export const MANIFEST_LIST_COLUMNS = [
  {
    accessorKey: 'manifest_code',
    header: 'Manifest Code',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { id, manifest_code } = original;

      return (
        <Link to={paths.manifestsDetails(id)}>
          <strong>{manifest_code}</strong>
        </Link>
      );
    },
  },
  {
    accessorKey: 'channel',
    header: 'Channel',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { channel } = original;

      return <span>{channel?.channel_type}</span>;
    },
  },
  {
    accessorKey: 'shipping_provider',
    header: 'Shipping Provider',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { shipping_provider } = original;

      return <span>{shipping_provider?.shipping_provider_type || '-'}</span>;
    },
  },
  {
    accessorKey: 'shipping_method',
    header: 'Shipping Method',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { shipping_method } = original;

      return <span>{shipping_method || 'any'}</span>;
    },
  },
  {
    accessorKey: 'shipment_quantity',
    header: 'No. of Items',
    enableSorting: false,
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { shipment_quantity } = original;

      return <span>{shipment_quantity}</span>;
    },
  },
  {
    accessorKey: 'manifest_status',
    header: 'Status',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { manifest_status } = original;

      return (
        <SubtleBadge pill bg={getManifestBadgeColor(manifest_status)}>
          {formatStatus(manifest_status)}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'created',
    header: 'Created',
    enableSorting: true,
    meta: {
      meta: {
        valueType: 'string',
      },
    },
    cell: ({ row: { original } }) => {
      const { created } = original;

      return (
        <span>
          {new Date(created).toLocaleString('en-IN', TIME_OPTION) || '-'}
        </span>
      );
    },
  },
  {
    accessorKey: 'modified',
    header: 'Modified',
    enableSorting: true,
    meta: {
      meta: {
        valueType: 'string',
      },
    },
    cell: ({ row: { original } }) => {
      const { modified } = original;

      return (
        <span>
          {new Date(modified).toLocaleString('en-IN', TIME_OPTION) || '-'}
        </span>
      );
    },
  },
  {
    accessorKey: 'created_by',
    header: 'Generated By',
    meta: {
      meta: {
        valueType: 'string',
      },
    },
    cell: ({ row: { original } }) => {
      const { created_by } = original;

      return <span>{created_by?.email || '-'}</span>;
    },
  },
];

export const MANIFEST_DETAIL_SHIPMENT_COLUMNS = [
  {
    accessorKey: 'order',
    header: 'Order No',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { order } = original;

      return <span>{order.channel_order_id}</span>;
    },
  },
  {
    accessorKey: 'shipment_code',
    header: 'Shipment Code',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { shipment_code } = original;

      return <span>{shipment_code}</span>;
    },
  },
  {
    accessorKey: 'invoice_code',
    header: 'Invoice Code',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { invoice_code } = original;

      return <span>{invoice_code}</span>;
    },
  },
  {
    accessorKey: 'awb_number',
    header: 'AWB Number',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { awb_number } = original;

      return <span>{awb_number}</span>;
    },
  },
  {
    accessorKey: 'weight',
    header: 'Weight',
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { weight } = original;

      return (
        <span>
          {weight.value} ({weight.unit})
        </span>
      );
    },
  },
  {
    accessorKey: 'package_width',
    header: 'Package Dimensions (mm)',
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { package_width, package_length, package_height } = original;

      return (
        <span>
          {package_width} x {package_length} x {package_height}
        </span>
      );
    },
  },
];
